import React, {useRef} from 'react';

import {Box, Typography} from '@mui/material';
// eslint-disable-next-line import/no-cycle
import {useTranslation} from 'react-i18next';

import {useAppMode} from 'hooks/useAppMode';
import ReactNative from 'services/react-native';
import {ProductSectionProps} from 'types';
import {ProductSummaryList} from 'views/unavailable-section-list/ProductSummaryList';

import {StyledSectionContentContainer, StyledSectionWrapV2, StyledUnavailableSectionHeader} from './styles';

export type BasketProps = {
  open: boolean;
  toggleBasketDrawer: () => void;
};

export const UnavailableExpressSectionV2: React.FC<ProductSectionProps> = ({mode, data}) => {
  const {t} = useTranslation();
  const divRef = useRef<HTMLDivElement>();
  const {isExpress} = useAppMode();

  const isReactNativeWebView = ReactNative.isReactNativeWebView();

  return (
    <>
      <StyledSectionWrapV2
        className={`${mode} ${'v2'}`}
        isReactNativeView={isReactNativeWebView}
        data-test-id={'unified_basket_unavailable_section'}
      >
        <StyledSectionContentContainer ref={divRef}>
          <StyledUnavailableSectionHeader isReactNativeView={isReactNativeWebView}>
            <Typography fontSize={14} fontWeight={600}>
              {isExpress
                ? t('unifiedBasket.title.unavailableForExpressDelivery')
                : t('unifiedBasket.title.unavailableForStorePickup')}
            </Typography>
          </StyledUnavailableSectionHeader>
          <Box padding={'8px 16px 0px 16px'}>
            <Typography fontSize={12} lineHeight={1.75}>
              {t('unifiedBasket.message.unavailableMessage')}
            </Typography>
          </Box>
          <ProductSummaryList parentRef={divRef} products={data} />
        </StyledSectionContentContainer>
      </StyledSectionWrapV2>
    </>
  );
};

UnavailableExpressSectionV2.displayName = 'UnavailableExpressSectionV2';
